Namespace 'Customer.Filters.EditCustomAttributes'

class Customer.Filters.EditCustomAttributes.EditHierarchicalTagsView extends Backbone.View
  className: 'filter-field-container filter-custom-attribute-container'
  template: JST['backbone/templates/customer/filters/tabs/edit_custom_attributes/edit_hierarchical_tags']
  events:
    'click .open-hierarchical-tags-modal-btn': 'openHierarchicalTagsFilterModal'

  initialize: ({customAttribute, filter, editable}) ->
    @customAttribute = customAttribute
    @editable = editable
    allAttributesValues = filter.get('query').custom_attributes.hierarchical_tags || []
    values = allAttributesValues.find((tag) => tag.code == @customAttribute.code)?.values
    @tagViews = []
    @setSelectedValues(values || [])

  setSelectedValues: (selectedValues) =>
    @attributeFilter = new CustomerVisualMode.Filters.HierarchicalTagsAttributeFilter(
      values: selectedValues
      attribute: new AccountSettings.ConversationAttribute(@customAttribute)
    )

  render: =>
    @$el.html(
      @template(
        attributeName: @customAttribute.name
      )
    )
    @renderSelectedValues()
    @

  renderSelectedValues: =>
    $tags = @$el.find('.tags')
    for tagView in @tagViews
      tagView.remove()
    @tagViews = []
    for value in @attributeFilter.getValues()
      tagView = new Customer.Filters.EditCustomAttributes.AppliedTagView(value)
      @listenTo(tagView, 'remove', @onRemoveValueCode)
      @tagViews.push(tagView)
      tagView.render()
      $tags.append(tagView.el)

  onRemoveValueCode: ({code}) =>
    @setSelectedValues(_.without(@attributeFilter.getValues().map((value) -> value.code), code))
    @renderSelectedValues()

  openHierarchicalTagsFilterModal: =>
    @hierarchicalTagsFilterView?.remove()
    @hierarchicalTagsFilterView = new CustomerVisualMode.Filters.SingleFilters.HierarchicalTagsFilterView(
      values: @customAttribute.hierarchical_tags.tags
      placeholder: I18n.t('common.session.filters.hierarchical_tags.modal.placeholder')
      acceptButtonText: I18n.t('customer.dashboard.filters.modal.apply')
      title: @customAttribute.name
      selectedOptions: @attributeFilter.getValues().map((value) -> value.code)
      editable: @editable
    ).render()
    @listenTo @hierarchicalTagsFilterView, 'filters:multiplevalues:apply', =>
      @setSelectedValues(@hierarchicalTagsFilterView.getSelectedValues())
      @renderSelectedValues()

  getValuesForFilter: =>
    code: @customAttribute.code
    values: @attributeFilter.getValues().map((value) -> value.code)
